import { render, staticRenderFns } from "./TraitBadge.vue?vue&type=template&id=f6aa537a"
import script from "./TraitBadge.vue?vue&type=script&lang=js"
export * from "./TraitBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports